import gql from "graphql-tag";

const GetCdcLevels = gql`
  query getCdcLevels {
    getCdcLevels
  }
`;

export default GetCdcLevels;
